
import DoughnutChart from "@/components/DoughnutChart.vue";
import CommissionService from "@/services/auth/CommissionService";
import randomColor from "randomcolor";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

interface dataChart {
  datasets: [
    {
      data: Array<number>;
      backgroundColor: Array<String>;
    }
  ];
  labels: Array<String>;
}

@Component({
  components: { DoughnutChart }
})
export default class TabulationsShareGraphic extends Vue {
  @Prop()
  private firstDate;

  @Prop()
  private lastDate;

  @Prop()
  private action;

  @Prop()
  private plugin;

  @Prop()
  private squad;

  @Prop()
  private metrics;

  @Prop()
  private metricsUser;

  @Prop()
  private loadingMetric;

  @Watch("loadingMetric", { immediate: false, deep: false })
  onLoadingMetricChanged(val: any, oldVal: any) {
    if (this.loadingMetric)
      this.getTabulationsShare(this.firstDate, this.lastDate);
  }

  private CommissionServiceInstance = new CommissionService();

  private title = {
    user: "Desempenho individual",
    squad: "Desempenho geral"
  };

  private totalRefusal: Number = 0;

  private get chartStyles() {
    return {
      height: '400px',
      width: "100%",
      position: "relative"
    };
  }

  private optChart = {
    title: {
      display: false,
      text: this.title.user
    },
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 50,
    rotation: 0,
    animation: {
      animateRotate: true,
      animateScale: false
    },
    legend: {
      display: true,
      position: "bottom",
      align: "start",
      labels: {
        boxWidth: 20,
        fontSize: 10,
        usePointStyle: true
      }
    }
  };

  private dataChart: dataChart = {
    datasets: [
      {
        data: [],
        backgroundColor: []
      }
    ],
    labels: []
  };

  private chartLoading = false;

  private getTabulationsShare(firstDate: any, lastDate: any) {
    this.chartLoading = true;

    if (this.squad)
        this.optChart.title.text = `${this.title.squad}`;
    else
        this.optChart.title.text = `${this.title.user}`;

    let response;
    if (this.squad)
        response = this.CommissionServiceInstance.squadTabulationsShare(
            this.$moment(new Date(firstDate)).format("YYYY-MM-DD"),
            this.$moment(new Date(lastDate)).format("YYYY-MM-DD"),
            this.action,
            this.plugin
        );
    else
        response = this.CommissionServiceInstance.userTabulationsShare(
            this.$moment(new Date(firstDate)).format("YYYY-MM-DD"),
            this.$moment(new Date(lastDate)).format("YYYY-MM-DD"),
            this.action,
            this.plugin
        );

    response.then((result: any) => {
        let refusal = result;
        let others = 0;
        if(result.refusal)
            refusal = result.refusal;

        let formatData: dataChart = {
            datasets: [
                {
                    data: [],
                    backgroundColor: []
                }
            ],
            labels: []
        };

        if (refusal && refusal.refusal_tabulations &&
            Object.keys(refusal.refusal_tabulations).length > 0) {
            refusal.refusal_tabulations.sort((a, b) => {
                const number1 = a[1];
                const number2 = b[1];

                let comparison = 0;
                if (number1 > number2) {
                    comparison = 1;
                } else if (number1 < number2) {
                    comparison = -1;
                }
                return comparison * -1;
            });

            for (const element of refusal.refusal_tabulations) {
                let label = element[0];
                label = `${label} (${((element[1] * 100) / refusal.total_refusal).toLocaleString(
                "pt-br",
                { minimumFractionDigits: 1, maximumFractionDigits: 1 }
                )}%)`
                if(element[1] > 1 || refusal.refusal_tabulations.length < 8){
                    formatData.labels.push(label);
                    formatData.datasets[0].data.push(element[1]);
                    formatData.datasets[0].backgroundColor.push(randomColor());
                }else{
                    others += element[1];
                }
            }

            if(others > 0){
                const label = `Outros (${((others * 100) / refusal.total_refusal).toLocaleString(
                    "pt-br",
                    { minimumFractionDigits: 1, maximumFractionDigits: 1 }
                )}%)`
                formatData.labels.push(label);
                formatData.datasets[0].data.push(others);
                formatData.datasets[0].backgroundColor.push(randomColor());
            }
        }

        this.totalRefusal = refusal.total_refusal;
        this.dataChart = formatData;
        this.chartLoading = false;
    });
  }

  private getMetric(funnelLeadType: string) {
    if (this.optChart.title.text === 'Desempenho individual') {
      let totalLeads: any = this.metricsUser && this.metricsUser.funnel? 
        Object.values(this.metricsUser.funnel).find((e: any) => e.name === funnelLeadType) : "-"
      return totalLeads && (totalLeads.value || totalLeads.value === 0) ? totalLeads.value : "-"
    } else if (this.optChart.title.text === 'Desempenho geral') {
      let totalLeads: any = this.metrics && this.metrics.funnel?
        Object.values(this.metrics.funnel).find((e: any) => e.name === funnelLeadType) : "-"
      return totalLeads && (totalLeads.value || totalLeads.value === 0) ? totalLeads.value : "-"
    } else {
      return "-"
    }
  }

  private isValidCalcConversionsPercent(): boolean {
    if (
      this.metricsUser &&
      this.metricsUser.funnel &&
      Object.values(this.metricsUser.funnel).find((e: any) => e.name === "total_leads_finished") &&
      Object.values(this.metricsUser.funnel).find((e: any) => e.name === "total_conversions")
    ) {
      return true
    }
    return false
  }

  private created() {
    this.getTabulationsShare(
      this.$moment().format("YYYY/MM/DD"),
      this.$moment().format("YYYY/MM/DD")
    );
  }
}
